import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  linkTo?: string;
  linkLabel?: string;
}

export default function EmptyState({
  icon = "ri-inbox-archive-line",
  title,
  description,
  actionLabel,
  onAction,
  linkTo,
  linkLabel,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4 rounded-lg border border-dashed border-background-300 bg-background-50">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 text-accent-700 text-3xl mb-4">
        <i className={icon}></i>
      </span>
      <h3 className="font-display font-bold text-lg text-foreground-950">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>}
      <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
        {onAction && actionLabel && (
          <button
            type="button"
            onClick={onAction}
            className="inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-4 py-2 text-sm font-bold text-white hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-refresh-line w-4 h-4 flex items-center justify-center"></i>
            {actionLabel}
          </button>
        )}
        {linkTo && linkLabel && (
          <Link
            to={linkTo}
            className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            {linkLabel}
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        )}
      </div>
    </div>
  );
}